import Swal from "sweetalert2"

// ! TODO: merge some fun together (ex. delete alert)

/**
 * show an error toast
 */
function errorToast(msg) {
    let type = 'error'

    Toast(type, msg, {
        showConfirmButton: false, timer: 2000,
    })
}

/**
 * show a success toast
 */
function successToast(msg) {
    let type = 'success'

    Toast(type, msg, {
        showConfirmButton: false, timer: 2000,
    })
}


/**
 * a message that shows when the user delete
 */
function deleteAlert() {
    let type = '',
        title = 'Are you sure?',
        text = 'cancel this request',
        options = {
            toast: false,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!'
        }

    return Toast(type, title, options, text)
}

function Toast(type, title, options = {}, text = '') {

    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        ...options
    })

    return Toast.fire({
        icon: type,
        title,
        text
    })

}

export {
    errorToast,
    deleteAlert,
    successToast,
}
